import { useState, useEffect } from 'react';
import * as JspUtil from '../common/JspUtil';
import submitHiddenForm from '../common/submitHiddenForm';
import { useJspVariables, useAppContext, useDebugRender } from '../hooks';
import { Dropdown, IceIcon, PageContainer } from '../components';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
const PageSamlChooseApp = () => {
    useDebugRender('PageSamlChooseApp');
    const { launcher, panelStyle, jspVariables } = useJspVariables();
    const { getLabelFromJspVariables } = useAppContext(jspVariables);

    const [app, setApp] = useState('');
    const [appOptions, setAppOptions] = useState([]);
    const [samlMessage, setSamlMessage] = useState('');
    const [samlResponse] = useState(() => {
        return JspUtil.isValueAvailable(window.jspSAMLResponse) ? window.jspSAMLResponse : '';
    });

    useEffect(() => {
        if (JspUtil.isValueAvailable(window.jspSamlMessage)) {
            setSamlMessage(window.jspSamlMessage);
        }
        const options = [];
        if (JspUtil.isValueAvailable(window.jspSamlApps)) {
            const samlApps = JSON.parse(window.jspSamlApps);
            Object.keys(samlApps).forEach(function (key) {
                options.push({ description: samlApps[key], appKey: key });
            });
        }
        setAppOptions(options);
    }, []);

    const onLoginClick = () => {
        submitHiddenForm('/samlauth', {
            SAMLResponse: samlResponse,
            selectedApp: app,
        });
    };

    return (
        <PageContainer id="pageSamlMessage" dataAutomationId="page_saml_message">
            <Box style={panelStyle}>
                <IceIcon launcher={launcher} />
                <Box>
                    <Typography fontWeight={500}>{getLabelFromJspVariables('title_choose_saml_app')}</Typography>
                    {samlMessage && <Typography variant="body2">{samlMessage}</Typography>}
                </Box>
                <Box>
                    <Typography fontWeight={500}>{getLabelFromJspVariables('label_application')}</Typography>
                    <Dropdown selectedValue={app}
                        labelProperty="description"
                        valueProperty="appKey"
                        options={appOptions}
                        id="saml_choose_app_select"
                        name="loginApp"
                        dataAutomationId="saml_choose_app_select"
                        updateValue={val => setApp(val)} />
                </Box>
                <Button variant="contained" fullWidth
                    onClick={onLoginClick}
                    data-automation-id="saml_choose_app_login_btn">
                    {getLabelFromJspVariables('action_login')}
                </Button>
            </Box>
        </PageContainer>
    );
};

export default PageSamlChooseApp;
